
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import React, { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { AppProps } from 'next/app';
import { Provider } from 'jotai';
import { AuthProvider } from '../contexts/auth';
import Alert from '../containers/Alert';
import Layout from '../containers/Layout';
import GlobalModal from '../containers/GlobalModal';
import usePresistLocale from '../hooks/usePresistLocale';
import { prefix } from '../utils/helpers';
import Tracking from '../utils/tracking';
import hubspot from '../utils/hubspot';
import '@spaceshipapp/cambridge/dist/cambridge.css';
import '../styles/globals';

const App = ({ Component, pageProps }: AppProps): React.ReactElement => {
  usePresistLocale();
  const router = useRouter();

  const { locales = [], defaultLocale, asPath } = router;

  useEffect(() => {
    const handleRouteChange = (path: string) => {
      const title = window?.document?.title || '';
      Tracking.page(title, { path });
      hubspot.refresh();
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  return (
    <Provider>
      <Head>
        {locales.map((locale) => (
          <link
            key={locale}
            rel="alternate"
            hrefLang={locale}
            href={`${prefix(locale, defaultLocale)}${asPath}`}
          />
        ))}
        <link rel="alternate" hrefLang="x-default" href={asPath} />
      </Head>
      <AuthProvider>
        <Layout>
          <Component {...pageProps} />
          <Alert />
          <GlobalModal />
        </Layout>
      </AuthProvider>
    </Provider>
  );
};

const __Page_Next_Translate__ = App;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      
// @ts-ignore
    });
// @ts-ignore
  